module.exports = __webpack_public_path__ + "static/img/miraj-logo.ef61b84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/miraj-logo.svg
// module id = pKD2
// module chunks = 12